import create from 'zustand';
import { NotesQueryState } from './interfaces/CreateQueryState';
import { createCommonNotesQuerySlice } from './slices/NotesQuerySlices/CommonNotesQuerySlice';

export const useNotesQueryStore = create<NotesQueryState>((set) => ({
  ...createCommonNotesQuerySlice(set)
}));
